module.exports = __webpack_public_path__ + "media/yorkshireterrier_k_yes.9999b478.mp3";